import React from 'react';

import App from './App';
import { createRoot } from 'react-dom/client';

/**
 * TODO: Uncomment this when Sentry compatibility issue with React 18 is resolved
 * Sentry.init(
 *   {
 *     dsn: 'https://07644b11feb3df7701d133c7a0cfc4fe@o4508400100048896.ingest.us.sentry.io/4508400101228544',
 *     release: `odonto-dashboard@50.0.23`,
 *     dist: '1',
 *     integrations: [
 *       // @ts-ignore
 *       Sentry.browserTracingIntegration(),
 *       // @ts-ignore
 *       Sentry.replayIntegration()
 *     ],
 *     ignoreErrors: [
 *       'No clinic or dentist found with this mobile number. Please sign up.',
 *       'No clinic found with this mobile number. Please sign up.'
 *     ],
 *     tracesSampleRate: 1.0,
 *     replaysSessionSampleRate: 0.1,
 *     replaysOnErrorSampleRate: 1.0,
 *     enabled: import.meta.env.PROD
 *   },
 *   SentryReact.init
 * );
 */

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
